import reduxModule from './redux';

export default reduxModule;